import React from 'react'
import { Box, Typography } from '@mui/material'

import TableActionButtons from '../../../components/action_button/TableActionButtons'
import MobileEmptyStateCard from '../../../components/MobileEmptyStateCard'
import { REFUND_APPROVAL_TEXT } from '../../constants/refundApprovalText'
import { getRefundLineListKey } from '../../helpers/refundApprovalUtils'
import { UI_TEXT_COPY_TABLE, UI_TEXT_DOWNLOAD_TABLE } from '../../../constants/uiText'
import {
  UI_COLOR_BORDER_CANCEL,
  UI_COLOR_BORDER_UTILITY_MOBILE,
  UI_COLOR_PRIMARY,
  UI_COLOR_PRIMARY_ALT_HOVER,
  UI_COLOR_SHADOW_PRIMARY_ACTION,
  UI_COLOR_SHADOW_UTILITY_ACTION,
  UI_COLOR_TEXT_SECTION,
  UI_COLOR_TEXT_SECTION_MUTED,
  UI_COLOR_TEXT_UTILITY_MOBILE,
  UI_COLOR_TEXT_UTILITY_MOBILE_HOVER,
  UI_COLOR_WHITE
} from '../../../constants/uiColors'
import RefundApprovalProductCard from './RefundApprovalProductCard'

const MOBILE_SECTION_UTILITY_BUTTON_SX = {
  width: { xs: 40, sm: 40 },
  height: { xs: 40, sm: 40 },
  borderRadius: '7px',
  border: `1px solid ${UI_COLOR_BORDER_UTILITY_MOBILE}`,
  color: UI_COLOR_TEXT_UTILITY_MOBILE,
  boxShadow: UI_COLOR_SHADOW_UTILITY_ACTION,
  '&:hover': {
    borderColor: UI_COLOR_BORDER_CANCEL,
    color: UI_COLOR_TEXT_UTILITY_MOBILE_HOVER,
    backgroundColor: UI_COLOR_WHITE,
    boxShadow: UI_COLOR_SHADOW_UTILITY_ACTION
  }
}

const MOBILE_SCAN_BUTTON_SX = {
  minHeight: { xs: 40, sm: 40 },
  borderRadius: '7px',
  fontSize: { xs: 16, sm: 16 },
  fontWeight: 500,
  letterSpacing: 0,
  boxShadow: UI_COLOR_SHADOW_PRIMARY_ACTION,
  '& .MuiButton-startIcon': {
    ml: 0,
    mr: 1.5
  },
  '& .material-symbols-outlined': {
    fontSize: { xs: '25px !important', sm: '25px !important' }
  },
  '&:hover': {
    boxShadow: UI_COLOR_SHADOW_PRIMARY_ACTION
  }
}

const RefundApprovalProductsSectionMobile = ({
  showLineActions,
  isFinalized,
  loading,
  lines,
  copyTooltip,
  onCopyTable,
  onDownloadCsv,
  onScan,
  onEditLine,
  onRejectLine
}) => (
  <>
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: 1.5,
        mb: showLineActions ? 3 : 2
      }}
    >
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography
          sx={{
            fontSize: { xs: 16, sm: 16 },
            fontWeight: 800,
            color: UI_COLOR_TEXT_SECTION,
            lineHeight: 1.15,
            letterSpacing: 0
          }}
        >
          {REFUND_APPROVAL_TEXT.productsHeading}
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: 14, sm: 14 },
            color: UI_COLOR_TEXT_SECTION_MUTED,
            mt: 1,
            lineHeight: 1.25,
            letterSpacing: 0
          }}
        >
          {showLineActions ? REFUND_APPROVAL_TEXT.scanHint : REFUND_APPROVAL_TEXT.productsRecord}
        </Typography>
      </Box>

      {(lines.length > 0 || showLineActions) && (
        <TableActionButtons
          utilityActions={[
            {
              label: UI_TEXT_COPY_TABLE,
              tooltip: copyTooltip,
              ariaLabel: REFUND_APPROVAL_TEXT.copyTableAria,
              icon: 'content_copy',
              iconSize: 22,
              onClick: onCopyTable,
              disabled: lines.length === 0,
              sx: MOBILE_SECTION_UTILITY_BUTTON_SX
            },
            {
              label: UI_TEXT_DOWNLOAD_TABLE,
              visible: !isFinalized,
              ariaLabel: REFUND_APPROVAL_TEXT.downloadTableAria,
              icon: 'download_2',
              iconSize: 22,
              onClick: onDownloadCsv,
              disabled: lines.length === 0,
              sx: MOBILE_SECTION_UTILITY_BUTTON_SX
            }
          ]}
          gap={1.5}
        />
      )}
    </Box>

    {showLineActions && (
      <Box sx={{ mb: 3.5, width: '100%' }}>
        <TableActionButtons
          utilityActions={[]}
          primaryAction={{
            label: REFUND_APPROVAL_TEXT.scan,
            icon: 'barcode_scanner',
            iconSize: 34,
            color: UI_COLOR_PRIMARY,
            hoverColor: UI_COLOR_PRIMARY_ALT_HOVER,
            onClick: () => onScan(),
            disabled: loading,
            fullWidth: true,
            sx: MOBILE_SCAN_BUTTON_SX
          }}
          sx={{ width: '100%' }}
        />
      </Box>
    )}

    {lines.length > 0 ? (
      lines.map((line, index) => (
        <RefundApprovalProductCard
          key={getRefundLineListKey(line, index)}
          line={line}
          showLineActions={showLineActions}
          loading={loading}
          onEditLine={onEditLine}
          onRejectLine={onRejectLine}
        />
      ))
    ) : (
      <MobileEmptyStateCard
        title={REFUND_APPROVAL_TEXT.emptyProducts}
        description={
          showLineActions ? REFUND_APPROVAL_TEXT.scanHint : REFUND_APPROVAL_TEXT.productsRecord
        }
      />
    )}
  </>
)

export default RefundApprovalProductsSectionMobile
